<template>
  <div>
    <div class="row items-center">
      <div class="col-grow">
        <SAIFormLabel class="text-center slider-label">
          Business Use
          <SAIInformationPopup>
            <p>
              You don’t need to have ‘business use’ to get a novated lease.
              Simply insert 0%, if your car is solely for personal use.
            </p>
          </SAIInformationPopup>
        </SAIFormLabel>
      </div>
      <span class="text-grey-6 text-paragraph">{{ value }} %</span>
    </div>
    <SAISlider
      :key="value"
      :disable="disable"
      :value="value"
      :min="0"
      :max="100"
      :step="1"
      snap
      @change="$emit('input', $event)"
    />
  </div>
</template>

<script>
import {
  SAIFormLabel,
  SAIInformationPopup,
  SAISlider
} from 'ecx.saigon.ui.common';

export default {
  name: 'BusinessUseSlider',
  props: {
    disable: Boolean,
    value: undefined
  },
  components: {
    SAIFormLabel,
    SAIInformationPopup,
    SAISlider
  }
};
</script>

<style lang="sass" scoped>
.slider-label
  margin-bottom: 0
</style>
